import c from "react";
const p = Symbol.for("react.forward_ref"), m = (e, o) => {
  const r = { ...o };
  for (const s in o) {
    const t = e[s], n = o[s];
    /^on[A-Z]/.test(s) ? t && n ? r[s] = (...f) => {
      n(...f), t(...f);
    } : t && (r[s] = t) : s === "style" ? r[s] = { ...t, ...n } : s === "className" && (r[s] = [t, n].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}, R = ({ children: e, ...o }, r) => e ? c.Children.toArray(e).map((t) => {
  if (c.isValidElement(t)) {
    const n = t, l = n.$$typeof, f = n.type.$$typeof, i = n.props, u = i.tgphRef;
    return l === p || f === p ? c.cloneElement(n, {
      ...m(o, i),
      tgphRef: u || r,
      ref: u || r
    }) : c.cloneElement(n, {
      ...m(o, i),
      tgphRef: u || r
    });
  }
  return t;
}) : null, d = c.forwardRef(
  ({ children: e, ...o }, r) => R({ children: e, ...o }, r)
), T = ({
  value: e,
  determinateValue: o,
  minDurationMs: r = 1e3
}) => {
  const [s, t] = c.useState(e), n = c.useRef(null), l = c.useRef(null), f = () => {
    n.current && (clearTimeout(n.current), n.current = null);
  }, i = c.useCallback(() => {
    if (e === o)
      f(), t(o), l.current = Date.now();
    else if (l.current !== null) {
      const u = Date.now() - l.current, a = r - u;
      a > 0 ? (f(), n.current = setTimeout(() => {
        t(e), l.current = null;
      }, a)) : (t(e), l.current = null);
    } else
      t(e);
  }, [e, o, r]);
  return c.useEffect(() => (i(), f), [e, i]), s;
};
export {
  d as RefToTgphRef,
  T as useDeterminateState
};
//# sourceMappingURL=index.mjs.map
